var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fseg",class:{ sm: _vm.small }},_vm._l((_vm.options),function(o){return _c('button',{key:o.value,class:{ on: Number(_vm.value) === Number(o.value) },attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('input', o.value)}}},[_vm._v(_vm._s(o.text))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }